import { render } from "./District.vue?vue&type=template&id=0857c9d1&scoped=true"
import script from "./District.vue?vue&type=script&lang=js"
export * from "./District.vue?vue&type=script&lang=js"

import "../assets/css/table.css?vue&type=style&index=0&id=0857c9d1&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0857c9d1"]])

export default __exports__